import { UtpCardStructure } from 'common/components';
import { ENTRANCE_DOORS_CDN_PATH } from '../../entrance-doors-constants';
import { IndividualSize, SoundInsulation, ReliableLocks, VestibuleDoor } from './components';

export const ENTRANCE_DOORS_APARTMENT_CARD_LIST: UtpCardStructure<{
  onConsultationSignupBtnClick: () => void;
}>[] = [
  {
    elementName: 'Индивидуальные размеры',
    header: {
      title: 'Индивидуальные размеры',
    },
    description: {
      text: 'Изготовим дверь под\u00A0любой проём',
    },
    image: {
      alt: 'Индивидуальные размеры двери',
      src: `${ENTRANCE_DOORS_CDN_PATH}/apartment-section/individual-size.png/individual-size.png`,
    },
    modal: { content: IndividualSize },
  },
  {
    elementName: 'Высокий уровень шумоизоляции',
    header: {
      title: 'Высокий уровень шумоизоляции',
    },
    description: {
      text: 'Позаботимся, чтобы вы\u00A0не слышали соседей',
    },
    image: {
      alt: 'Шумоизоляция двери',
      src: `${ENTRANCE_DOORS_CDN_PATH}/apartment-section/sound-insulation.png/sound-insulation.png`,
    },
    modal: { content: SoundInsulation },
  },
  {
    elementName: 'Надёжная система замков',
    header: {
      title: 'Надёжная система замков',
    },
    description: {
      text: 'Обеспечим высококлассную защиту от\u00A0взломов',
    },
    image: {
      alt: 'Надёжные замки для двери',
      src: `${ENTRANCE_DOORS_CDN_PATH}/apartment-section/reliable-locks.png/reliable-locks.png`,
    },
    modal: { content: ReliableLocks },
  },
  {
    elementName: 'Прочные двери в тамбур',
    header: {
      title: 'Прочные двери в\u00A0тамбур',
    },
    description: {
      text: 'Установим дополнительную дверь для секции квартир',
      mobileText: 'Установим специальную дверь для секции квартир',
    },
    image: {
      alt: 'Дверь в тамбур',
      src: `${ENTRANCE_DOORS_CDN_PATH}/apartment-section/vestibule-door.png/vestibule-door.png`,
    },
    modal: { content: VestibuleDoor },
  },
];
